export default __webpack_public_path__ + "static/media/you.6f7238b9.svg";